import React, { useEffect, useState } from "react";
import "./index.scss";
import Select from "react-select";
import { Formik } from "formik";
import { getSubCategoriesWithCount } from "../../services/get-subCategories-with-count-prod";
import { toast } from "react-toastify";
import { getSingleProdWithImages } from "../../services/get-single-prod-with-photos";
import WizardSteps from "../WizardSteps";
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    height: "30px",
    borderRadius: "9px",

    border: "none",
    backgroundColor: "#e2e2e2",
    boxShadow: state.isFocused ? "0 0 0 1px red" : "none",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "13px",
    color: "#000",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "white",
    color: "black",
    "&:hover": {
      backgroundColor: "orange",
      color: "white",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "black", // Color of the selected option text
  }),
};

const ModalProduct = ({
  setStep,
  productsValues,
  setProductsValues,
  editMode,
  closeModal,
  step,
  selectedOption,
  setSelectedOption,
}) => {
  const [subCategories, setSubCategories] = useState([]);
  const doGetSubCategories = () => {
    getSubCategoriesWithCount()
      .then((response) => {
        if (response?.status === 500) {
          toast.error("Internal Server Error !");
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          setSubCategories(response?.content);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    doGetSubCategories();
  }, []);
  const filteredOptions = subCategories.map((category) => ({
    label: category.name,
    value: category._id,
  }));

  const handleOptionSelectToStore = (option: any): void => {
    setSelectedOption(option);
  };
  return (
    <div className="product-modal-container">
      <div className="product-modal-header">
        <span className="title-txt">
          {editMode ? "Edit Produit " : "Ajouter Produit"}
        </span>
        <i
          className="bx bx-x"
          style={{ fontSize: 22, fontWeight: 700 }}
          onClick={() => closeModal()}
        ></i>
      </div>

      <WizardSteps current={1} />

      <div className="product-modal-body">
        <Formik
          initialValues={productsValues}
          validate={(values) => {
            const errors: any = {};
            if (!values.name) {
              errors.name = "Required";
            }
            if (!values.quantity) {
              errors.quantity = "Required *";
            }
            if (!values.description) {
              errors.description = "Required *";
            }
            if (!values.price) {
              errors.price = "Required *";
            }
            if (!values.weight) {
              errors.weight = "Required *";
            }

            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              setProductsValues(values);
              setStep("second");
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue, // Add setFieldValue from Formik
          }: any) => (
            <form
              className="form-container"
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                background: "#fff",
              }}
              onSubmit={handleSubmit}
            >
              <div className="modal-inputs-row">
                <div style={{ width: "100%", padding: 5 }}>
                  <span className="title-name-txt">Sous Categorie</span>

                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="ex: iphone"
                    options={filteredOptions}
                    value={selectedOption}
                    styles={customStyles}
                    onChange={handleOptionSelectToStore}
                  />
                </div>
              </div>
              <div className="modal-inputs-row">
                <div className="input-title-container">
                  <span className="title-name-txt">Product Name</span>
                  <input
                    name="name"
                    className="input-name-style"
                    type="text"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="product name"
                  />
                  {errors.name && touched.name && (
                    <span style={{ color: "red" }}>{errors?.name}</span>
                  )}
                </div>
                <div className="input-title-container">
                  <span className="title-name-txt">Description</span>
                  <input
                    name="description"
                    className="input-description-style"
                    type="text"
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="description ..."
                  />
                  {errors.description && touched.description && (
                    <span style={{ color: "red" }}>{errors?.description}</span>
                  )}
                </div>
              </div>
              <div className="modal-inputs-row">
                <div className="input-title-container">
                  <span className="title-name-txt">Price</span>
                  <input
                    name="price"
                    className="input-name-style"
                    type="number"
                    value={values.price}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="price $"
                  />
                  {errors.price && touched.price && (
                    <span style={{ color: "red" }}>{errors?.price}</span>
                  )}{" "}
                </div>
                <div className="input-title-container">
                  <span className="title-name-txt">Qunatity</span>
                  <input
                    name="quantity"
                    className="input-name-style"
                    type="number"
                    value={values.quantity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="ex: 50"
                  />
                  {errors.quantity && touched.quantity && (
                    <span style={{ color: "red" }}>{errors?.quantity}</span>
                  )}{" "}
                </div>
              </div>
              <div className="modal-inputs-row">
                <div className="input-title-container">
                  <span className="title-name-txt">Solde</span>
                  <input
                    name="sold"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.sold}
                    className="input-name-style"
                    type="number"
                    placeholder="sold %"
                  />
                  {errors.sold && touched.sold && (
                    <span style={{ color: "red" }}>{errors?.sold}</span>
                  )}{" "}
                </div>
                <div className="input-title-container">
                  <span className="title-name-txt">Stockage</span>
                  <input
                    name="weight"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.weight}
                    className="input-name-style"
                    type="number"
                    placeholder="128 go"
                  />
                  {errors.weight && touched.weight && (
                    <span style={{ color: "red" }}>{errors?.weight}</span>
                  )}{" "}
                </div>
              </div>

              <div className="product-modal-footer">
                <span className="footer-hint">
                  Étape suivante : ajouter les photos
                </span>
                <button type="submit" className="btn-next">
                  Continuer <i className="bx bx-chevron-right"></i>
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ModalProduct;
